import { render, staticRenderFns } from "./UsersInRole.vue?vue&type=template&id=79b87a3a&scoped=true&"
import script from "./UsersInRole.vue?vue&type=script&lang=js&"
export * from "./UsersInRole.vue?vue&type=script&lang=js&"
import style0 from "./UsersInRole.vue?vue&type=style&index=0&id=79b87a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b87a3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
